// LoginScreen — Matrix v2 prihlasovacia obrazovka
// Pouziva komponenty Task #6 (Btn, Input) + theme.js (sek. 21.15)
// Backend: rovnaký /api/auth/login ako starý frontend → zdielana session.

import React, { useState } from 'react'
import { useAuth } from './AuthContext.jsx'
import { Btn } from '../components/Btn.jsx'
import { Input } from '../components/Input.jsx'
import { COLORS, RADIUS, TYPO, SPACE, SHADOW } from '../theme.js'

export default function LoginScreen() {
  const { login, error, setError } = useAuth()
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [showPw, setShowPw] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!username.trim() || !password) return
    setLoading(true)
    await login(username.trim(), password)
    setLoading(false)
  }

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: COLORS.bgSoft,
      fontFamily: TYPO.family,
      padding: SPACE.lg
    }}>
      <div style={{
        width: 380,
        maxWidth: '100%',
        background: COLORS.bg,
        border: `1px solid ${COLORS.line}`,
        borderRadius: RADIUS.xl,
        padding: '40px 36px',
        boxShadow: SHADOW.lg
      }}>
        {/* Brand — ústava 27.1 (Mirko 17. 10. 2026): IBA skutočné logo MATRIX | KAMIR „powered by“ z /data/uploads, bez rámu */}
        <div style={{ textAlign: 'center', marginBottom: SPACE.xxl }}>
          <img src="/uploads/matrix_logo_sirka_trim.png" alt="MATRIX powered by KAMIR"
            style={{ width: '100%', maxWidth: 270, height: 'auto', display: 'block', margin: '0 auto' }}
            onError={(e) => { e.currentTarget.style.display = 'none'; const f = e.currentTarget.nextSibling; if (f) f.style.display = 'block' }} />
          <div style={{ display: 'none', fontSize: 32, fontWeight: TYPO.weights.extra, color: COLORS.add, letterSpacing: '-0.03em', lineHeight: 1 }}>Matrix</div>
        </div>

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: SPACE.md }}>
          <Input
            label="Prihlasovacie meno"
            value={username}
            onChange={(v) => { setUsername(v); setError && setError('') }}
            placeholder="napr. mirko"
            autoFocus
            fullWidth
            autoCapitalize="none"
            autoCorrect="off"
            spellCheck={false}
          />

          <div style={{ position: 'relative' }}>
            <Input
              label="Heslo"
              type={showPw ? 'text' : 'password'}
              value={password}
              onChange={(v) => { setPassword(v); setError && setError('') }}
              placeholder="••••••••"
              fullWidth
              inputStyle={{ paddingRight: 40 }}
            />
            <button
              type="button"
              onClick={() => setShowPw(s => !s)}
              aria-label={showPw ? 'Skryť heslo' : 'Zobraziť heslo'}
              style={{
                position: 'absolute',
                right: 10,
                bottom: 6,
                background: 'transparent',
                border: 'none',
                cursor: 'pointer',
                color: COLORS.muted,
                fontSize: 16,
                padding: 4
              }}
            >{showPw ? 'Skryť' : 'Zobraziť'}</button>
          </div>

          {error && (
            <div role="alert" style={{
              background: COLORS.removeBg,
              border: `1px solid ${COLORS.remove}`,
              borderRadius: RADIUS.md,
              padding: '8px 12px',
              color: COLORS.remove,
              fontSize: TYPO.sizes.sm,
              textAlign: 'center'
            }}>{error}</div>
          )}

          <Btn
            type="submit"
            variant="add"
            size="lg"
            fullWidth
            loading={loading}
            disabled={loading || !username.trim() || !password}
            style={{ marginTop: SPACE.sm }}
          >
            {loading ? 'Prihlasujem…' : 'Prihlásiť sa →'}
          </Btn>
        </form>

        <div style={{
          textAlign: 'center',
          marginTop: SPACE.xl,
          fontSize: TYPO.sizes.xs,
          color: COLORS.muted
        }}>
          Matrix v2 · powered by KAMiR s.r.o.<br/>
          Starý Matrix beží na <a href="http://kamir.ksbx.sk" style={{ color: COLORS.nav }}>kamir.ksbx.sk</a>
        </div>
      </div>
    </div>
  )
}
